module.exports = __webpack_public_path__ + "static/media/bgpjet.7a7b6657.jpg";